import React from 'react'
import classNames from 'classnames'
import DropDownClearIcon from '../../dropDownClearIcon'
import './index.less'

export type TDisplay = {
  displayTextClassName?:string,
  className?:string,
  displayStyle?:React.CSSProperties,
  value:string | number,
  options: Array<any>,
  placeholder?:string,
  visible:boolean,
  onClear?: ()=> void,
  allowClear?:boolean,
}

export const SelectDisplay = ({
  displayTextClassName,
  className,
  displayStyle,
  value = null,
  options = [],
  placeholder = '请选择',
  visible,
  onClear,
  allowClear = true, }:TDisplay) => {
  return <span className={classNames('mn-select-display', 'dropDownClearIcon', displayTextClassName, className, { clear: (value || value === 0) && allowClear, active: (value || value === 0) && allowClear })} style={displayStyle}>
    <DropDownClearIcon visible={visible} onClear={() => onClear()}>
      <span className="text-overflow">{options.find(m => value === m.value)?.label || placeholder}</span>
    </DropDownClearIcon>
  </span>
}
